export default "__VITE_ASSET__8e633fb4__"